import React, { PureComponent } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import Masonry from "react-masonry-component";
import PostContainer from "../../../RawData/Post/PostContainer";

class RawConversationPosts extends PureComponent {
    render() {
        return (
            <Scrollbars autoHide id="scroll-div">
                <Masonry
                    className={"masonry-layout"}
                    style={{ marginTop: "5px" }}
                    elementType={"section"}
                    enableResizableChildren={true}
                    disableImagesLoaded={false} // default false
                    options={{
                        transitionDuration: 0,
                        fitWidth: true,
                    }} // default {}
                    updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
                >
                    {this.props.data.map((el, ind) => (
                        <PostContainer
                            key={el._id}
                            data={el}
                            appliedFilter={this.props.appliedFilter}
                            index={ind}
                            postIndex={ind}
                            company={this.props.company}
                            customQuery={this.props.appliedFilter?.custom_query}
                            className="post-container-analytics-widget"
                            LNOfflineModalShow={(data) => this.props.LNOfflineModalShow(true, data)}
                            updatePostAfterSentimentUpdate={this.props.updatePostAfterSentimentUpdate}
                            updatePostAfterMarkAsIrr={this.props.updatePostAfterMarkAsIrr}
                            updatePostAfterTagToClient={this.props.updatePostAfterTagToClient}
                            downloadParentPostCsv={this.props.downloadParentPostCsv}
                            isPublic={this.props.isPublic}
                        />
                    ))}
                </Masonry>
            </Scrollbars>
        );
    }
}

export default RawConversationPosts;
